import { Field } from "formik";

import { FormFieldWrapper } from "../../../../organisms/form-field-wrapper";
import { FormikFormInputSelectSearch } from "../../form-input-select-search";

import { useSearch } from "./hooks/use-search";

interface IProps {
  id?: string;
  required?: boolean;
}

export const FormFieldHobby: React.FC<IProps> = ({ id = "hobby", required = false }) => {
  const onSearch = useSearch();

  return (
    <FormFieldWrapper label="Child's hobby or main interest" required={required} name={id}>
      <Field
        name={id}
        placeholder="Select hobby"
        component={FormikFormInputSelectSearch}
        loadOptions={onSearch}
        cacheOptions
      />
    </FormFieldWrapper>
  );
};
